import { render, staticRenderFns } from "./CopyText.vue?vue&type=template&id=ccb35106"
import script from "./CopyText.vue?vue&type=script&lang=ts"
export * from "./CopyText.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports